// src/components/common/EditableName.js
import React, { useState } from "react";
import { Button, Input, Modal, Tooltip } from "antd";
import { FaPen } from "react-icons/fa";

const EditableName = ({
  value,
  fallback = "Untitled",
  title = "Edit name",
  inputLabel = "Name",
  onSave,
  maxLength = 100,
  buttonText = "Edit",
  buttonAriaLabel = "Edit name",
  buttonVariant = "text",
  buttonClassName = "",
  displayClassName = "",
  className = "",
  iconSize = 10,
}) => {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(value || "");
  const [saving, setSaving] = useState(false);

  const displayName = value?.trim() || fallback;

  const handleOpen = () => {
    setDraft(value || "");
    setOpen(true);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave(draft.trim());
      setOpen(false);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={`flex items-center gap-2 min-w-0 ${className}`}>
      <Tooltip title={displayName}>
        <span className={`${!value ? "italic text-gray-500" : ""} truncate ${displayClassName}`}>
          {displayName}
        </span>
      </Tooltip>
      {buttonVariant === "icon" ? (
        <Button
          size="small"
          type="text"
          onClick={handleOpen}
          aria-label={buttonAriaLabel}
          className={`px-1 inline-flex items-center justify-center ${buttonClassName}`}
          icon={<FaPen size={iconSize} />}
        />
      ) : (
        <Button size="small" type="link" onClick={handleOpen} className={`px-1 ${buttonClassName}`}>
          {buttonText}
        </Button>
      )}
      <Modal
        title={<span className="text-gray-900">{title}</span>}
        open={open}
        onOk={handleSave}
        onCancel={() => setOpen(false)}
        confirmLoading={saving}
        okText="Save"
        okButtonProps={{ style: { color: "#ffffff" } }}
        cancelButtonProps={{ style: { color: "#111827" } }}
      >
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {inputLabel}
        </label>
        <Input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          maxLength={maxLength}
          showCount
          placeholder={fallback}
          className="!text-gray-900"
        />
        <p className="text-xs text-gray-500 mt-2">
          Leave blank to show the default untitled label.
        </p>
      </Modal>
    </div>
  );
};

export default EditableName;